export const normalizeRole = (role) => {
  if (role == null) {
    return null;
  }

  const rawRole = typeof role === "object" ? role.role_id : role;

  if (typeof rawRole === "number") {
    return Number.isFinite(rawRole) ? rawRole : null;
  }

  if (typeof rawRole === "string") {
    const trimmedRole = rawRole.trim();

    if (trimmedRole === "") {
      return null;
    }

    const normalizedRole = Number(trimmedRole);
    return Number.isNaN(normalizedRole) ? null : normalizedRole;
  }

  return null;
};

/**
 * Temporary prototype auth for local testing.
 * When enabled:
 *   - Login accepts any click (no credentials / API)
 *   - Private/Public routes trust the in-memory AuthProvider token only
 *   - Logout clears that token and returns to Login
 * Never enable outside development. Easy to remove when real auth returns.
 */
export const isDevAuthBypassEnabled = () => (
  process.env.NODE_ENV === "development"
  && process.env.REACT_APP_DEV_AUTH_BYPASS === "true"
);

/** In-memory session marker used by the prototype Login flow. */
export const DEV_AUTH_BYPASS_TOKEN = "dev-auth-bypass";

export const getDevAuthBypassProfile = () => ({
  first_name: "Local",
  last_name: "Dev",
  email: "local.dev@alphasearch.local",
  role: 1,
});
